import React from "react";
import { Box } from "@mui/material";

const PageContainer = React.forwardRef(function PageContainer(
  { children, sx },
  ref,
) {
  return (
    <Box ref={ref} sx={sx}>
      {children}
    </Box>
  );
});

export default PageContainer;
